import { api } from "./api";

export type GlobalSearchKind =
  | "user"
  | "order"
  | "payment"
  | "product"
  | "receipt"
  | "case"
  | "raffle"
  | "auction"
  | "discount";

export interface GlobalSearchItem {
  id: string;
  kind: GlobalSearchKind;
  title: string;
  subtitle: string;
  path: string;
}

export const SEARCH_KIND_LABEL: Record<GlobalSearchKind, string> = {
  user: "Customer",
  order: "Order",
  payment: "Payment",
  product: "Product",
  receipt: "Bank receipt",
  case: "Case",
  raffle: "Raffle",
  auction: "Auction",
  discount: "Discount",
};

export async function fetchGlobalSearch(query: string): Promise<GlobalSearchItem[]> {
  const data = await api<{ items: GlobalSearchItem[] }>(
    `/search?q=${encodeURIComponent(query)}`,
  );
  return data.items;
}
